var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabletIpad = function SvgTabletIpad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.6 18.2a.6.6 0 1 0 0-1.2v1.2m-4-1.2a.6.6 0 1 0 0 1.2V17M3.6.6v.6h10V0h-10zm13 3H16v14h1.2v-14zm-3 17V20h-10v1.2h10zm-13-3h.6v-14H0v14zm3 3V20a2.4 2.4 0 0 1-2.4-2.4H0a3.6 3.6 0 0 0 3.6 3.6zm13-3H16a2.4 2.4 0 0 1-2.4 2.4v1.2a3.6 3.6 0 0 0 3.6-3.6zm-3-17v.6A2.4 2.4 0 0 1 16 3.6h1.2A3.6 3.6 0 0 0 13.6 0zm-10 0V0A3.6 3.6 0 0 0 0 3.6h1.2a2.4 2.4 0 0 1 2.4-2.4zm7 17V17h-4v1.2h4z"
  })));
};
export default SvgTabletIpad;